import { ACCOUNT_PEP_BLOCK_QUERY, ACCOUNT_BLOCKS_UPDATED, ACCOUNT_PEP_BLOCK_UPDATED, ACCOUNT_PEP_DETAILS_UPDATED, ACCOUNT_PEP_DETAILS_QUERY, ACCOUNT_BLOCKS_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { ActiveBlockReasonId } from '@gig/magic-sdk/dist/adapter/users/getUserActiveBlocks';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class PepBlockService {
  constructor() {
    this.blocks = [];
    this.detailsQuerySubscription = null;
    this.loading = false;
    this.registerEvents();
    this.subscribeToQueries();
    this.subscribeToUserBlocksChanges();
  }
  subscribeToQueries() {
    window.queryBus.subscribe(ACCOUNT_PEP_BLOCK_QUERY, () => __async(this, null, function* () {
      this.blocks = yield window.queryBus.query(ACCOUNT_BLOCKS_QUERY);
      return this.isPepBlocked();
    }));
    this.subscribeDetailsQueries();
  }
  subscribeToUserBlocksChanges() {
    window.eventBus.subscribe(ACCOUNT_BLOCKS_UPDATED, (e) => __async(this, null, function* () {
      var _a;
      this.blocks = (_a = e.payload) != null ? _a : [];
      const isPepBlocked = this.isPepBlocked();
      window.eventBus.publish(ACCOUNT_PEP_BLOCK_UPDATED, isPepBlocked);
      if (isPepBlocked) {
        yield this.getPepDetails();
      } else {
        this.pepDetails = void 0;
      }
      window.eventBus.publish(ACCOUNT_PEP_DETAILS_UPDATED, this.pepDetails);
    }), { replay: true });
  }
  getPepDetails() {
    return __async(this, null, function* () {
      if (this.loading) {
        return;
      }
      this.unsubscribeDetailsQueries();
      try {
        this.loading = true;
        this.pepDetails = yield magic.methods.users.getPepDetails();
      } catch (e) {
        console.log("unable to get pep details", e);
      } finally {
        this.loading = false;
        this.subscribeDetailsQueries();
      }
    });
  }
  unsubscribeDetailsQueries() {
    var _a;
    (_a = this.detailsQuerySubscription) == null ? void 0 : _a.unsubscribe();
    this.detailsQuerySubscription = null;
  }
  subscribeDetailsQueries() {
    if (!this.detailsQuerySubscription) {
      this.detailsQuerySubscription = window.queryBus.subscribe(ACCOUNT_PEP_DETAILS_QUERY, () => {
        if (!this.isPepBlocked()) {
          return;
        }
        return this.pepDetails;
      });
    }
  }
  isPepBlocked() {
    return this.blocks.some(({ blockReasonId }) => blockReasonId === ActiveBlockReasonId.PoliticallyExposedPerson);
  }
  registerEvents() {
    window.queryBus.register(ACCOUNT_PEP_BLOCK_QUERY, {
      type: "boolean"
    });
    window.queryBus.register(ACCOUNT_PEP_BLOCK_UPDATED, {
      type: "boolean"
    });
  }
}

export { PepBlockService };
